import { useState } from 'react';
import { Save } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';

import { MAP_PROVIDERS, UNITS, TIMEZONES } from '../constants';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

export function SystemTabContent() {
  const [timezone, setTimezone] = useState('est');
  const [units, setUnits] = useState<'metric' | 'imperial'>('imperial');
  const [mapProvider, setMapProvider] = useState('mapbox');

  const save = () => {
    console.log({
      timezone,
      units,
      mapProvider,
    });
  };

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-slate-50">
        Device Information
      </h3>

      <div className="grid grid-cols-2 gap-x-8 gap-y-6 mb-8 pb-4">
        <div className="space-y-2">
          <Label>Device Name</Label>
          <Input
            type="text"
            placeholder="Device Name"
            readOnly
            className={cn('bg-slate-800/50 cursor-not-allowed')}
          />
        </div>

        <div className="space-y-2">
          <Label>Device ID</Label>
          <Input
            type="text"
            placeholder="Device ID"
            readOnly
            className={cn('bg-slate-800/50 cursor-not-allowed')}
          />
        </div>

        <div className="space-y-2">
          <Label>Device Type</Label>
          <Input
            type="text"
            placeholder="Device Type"
            readOnly
            className={cn('bg-slate-800/50 cursor-not-allowed')}
          />
        </div>

        <div className="space-y-2">
          <Label>Device Version</Label>
          <Input
            type="text"
            placeholder="Device Version"
            readOnly
            className={cn('bg-slate-800/50 cursor-not-allowed')}
          />
        </div>
      </div>

      <h3 className="text-lg font-semibold text-slate-50 mt-8 border-t pt-4">
        System Preferences
      </h3>

      {/* Core preferences */}
      <div className="space-y-4">
        <SelectField
          label="Timezone"
          value={timezone}
          onChange={setTimezone}
          options={TIMEZONES}
        />

        <SelectField
          label="Measurement Units"
          value={units}
          onChange={(val) => setUnits(val as 'metric' | 'imperial')}
          options={UNITS}
        />

        <SelectField
          label="Map Provider"
          value={mapProvider}
          onChange={setMapProvider}
          options={MAP_PROVIDERS}
        />
      </div>

      <div className="flex justify-end pt-4">
        <Button type="button" onClick={save}>
          <Save className="w-4 h-4" />
          <span>Save Changes</span>
        </Button>
      </div>
    </div>
  );
}

interface SelectFieldProps {
  readonly label: string;
  readonly value: string;
  readonly options: { value: string; label: string }[];
  readonly onChange: (value: string) => void;
}

function SelectField({ label, value, options, onChange }: SelectFieldProps) {
  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-full">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {options.map((opt) => (
              <SelectItem key={opt.value} value={opt.value}>
                {opt.label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
}
